import { css } from 'styled-components';

export const antdOverrides = css`
  /* Ant Design Select standardization */
  .ant-select:not(.ant-pagination-options-size-changer) {
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-family: ${({ theme }) => theme.fontFamily};
    width: 100%;
    height: 40px;
    transition: border-color ${({ theme }) => theme.transition.base};
  }

  .ant-select-multiple:not(.ant-pagination-options-size-changer) {
    height: auto !important;
    min-height: 40px;
  }

  .ant-select-focused:not(.ant-select-disabled),
  .ant-select-open:not(.ant-select-disabled) {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .ant-select .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    background-color: ${({ theme }) => theme.colors.surface} !important;
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: ${({ theme }) => theme.fontSize.base};
    height: 100% !important;
    padding: 0 ${({ theme }) => theme.spacing[3]} !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  /* Reset global input styles inside Select search */
  .ant-select-selector input,
  .ant-select-selection-search-input {
    height: 100% !important;
    border: none !important;
    padding: 0 !important;
    margin: 0;
    background-color: transparent !important;
    box-shadow: none !important;
    line-height: normal !important;
  }

  .ant-select-selection-search {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: ${({ theme }) => theme.spacing[3]};
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .ant-select-multiple .ant-select-selector {
    height: auto !important;
    min-height: 40px;
    flex-wrap: wrap !important;
    padding: 4px ${({ theme }) => theme.spacing[3]} !important;
  }

  .ant-select-multiple .ant-select-selection-item {
    height: 28px;
    line-height: 26px;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-size: ${({ theme }) => theme.fontSize.sm};
    background-color: ${({ theme }) => theme.colors.surfaceRaised};
    border-color: ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  /* Ant Design Dropdown - dark mode */
  .ant-select-dropdown {
    background-color: ${({ theme }) => theme.colors.surface} !important;
    border: 1px solid ${({ theme }) => theme.colors.border};
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  .ant-select-item {
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: ${({ theme }) => theme.colors.surfaceHover} !important;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: ${({ theme }) => theme.colors.primary.light} !important;
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  /* Ant Design Modal, Confirm & Popconfirm button standardization */
  .ant-modal-content {
    background-color: ${({ theme }) => theme.colors.surface} !important;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .ant-modal-header {
    background-color: ${({ theme }) => theme.colors.surface} !important;
    border-bottom-color: ${({ theme }) => theme.colors.border} !important;
  }

  .ant-modal-title {
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .ant-modal-close-x {
    color: ${({ theme }) => theme.colors.text.muted};
  }

  .ant-modal-footer {
    border-top-color: ${({ theme }) => theme.colors.border} !important;
  }

  .ant-modal-footer .ant-btn,
  .ant-modal-confirm-btns .ant-btn,
  .ant-popover-buttons .ant-btn {
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    text-transform: uppercase;
    transition: all ${({ theme }) => theme.transition.fast};

    &:hover {
      transform: translateY(-1px);
    }
  }

  .ant-modal-footer .ant-btn {
    font-size: ${({ theme }) => theme.fontSize.base};
    height: 40px;
    padding: 0 24px;
  }

  .ant-modal-footer .ant-btn:not(.ant-btn-primary),
  .ant-modal-footer .ant-btn:not(.ant-btn-primary):active,
  .ant-modal-confirm-btns .ant-btn:not(.ant-btn-primary),
  .ant-modal-confirm-btns .ant-btn:not(.ant-btn-primary):active,
  .ant-popover-buttons .ant-btn:not(.ant-btn-primary),
  .ant-popover-buttons .ant-btn:not(.ant-btn-primary):active {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[200]} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
    color: ${({ theme }) => theme.colors.text.secondary} !important;

    &:hover,
    &:focus {
      background-color: ${({ theme }) =>
        theme.mode === 'dark'
          ? theme.colors.surfaceHover
          : theme.colors.neutral[300]} !important;
      border-color: ${({ theme }) => theme.colors.borderHover} !important;
      color: ${({ theme }) => theme.colors.text.secondary} !important;
    }
  }

  .ant-modal-footer .ant-btn-primary,
  .ant-modal-footer .ant-btn-primary:active,
  .ant-modal-confirm-btns .ant-btn-primary,
  .ant-modal-confirm-btns .ant-btn-primary:active,
  .ant-popover-buttons .ant-btn-primary,
  .ant-popover-buttons .ant-btn-primary:active {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    color: #ffffff !important;

    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.colors.primary[700]} !important;
      border-color: ${({ theme }) => theme.colors.primary[700]} !important;
      color: #ffffff !important;
    }
  }

  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous,
  .ant-modal-footer .ant-btn-primary.ant-btn-dangerous:active,
  .ant-modal-confirm-btns .ant-btn-primary.ant-btn-dangerous,
  .ant-modal-confirm-btns .ant-btn-primary.ant-btn-dangerous:active,
  .ant-popover-buttons .ant-btn-primary.ant-btn-dangerous,
  .ant-popover-buttons .ant-btn-primary.ant-btn-dangerous:active {
    background-color: ${({ theme }) => theme.colors.error.base} !important;
    border-color: ${({ theme }) => theme.colors.error.base} !important;
    color: #ffffff !important;

    &:hover,
    &:focus {
      background-color: ${({ theme }) =>
        theme.colors.error.hover || theme.colors.error.dark} !important;
      border-color: ${({ theme }) =>
        theme.colors.error.hover || theme.colors.error.dark} !important;
      color: #ffffff !important;
    }
  }

  /* Ant Design button disabled state */
  .ant-modal-footer .ant-btn[disabled],
  .ant-modal-confirm-btns .ant-btn[disabled],
  .ant-popover-buttons .ant-btn[disabled] {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[300]} !important;
    color: ${({ theme }) => theme.colors.text.muted} !important;
    border-color: transparent !important;
    cursor: not-allowed;

    &:hover {
      transform: none;
    }
  }

  /* Ant Design button loading state */
  .ant-modal-footer .ant-btn-loading,
  .ant-modal-confirm-btns .ant-btn-loading,
  .ant-popover-buttons .ant-btn-loading {
    opacity: 0.8;
    pointer-events: none;
  }

  /* Ant Design Confirm modal - dark mode */
  .ant-modal-confirm-body .ant-modal-confirm-title {
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .ant-modal-confirm-body .ant-modal-confirm-content {
    color: ${({ theme }) => theme.colors.text.secondary} !important;
  }

  /* Ant Design Result - dark mode */
  .ant-result-title {
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .ant-result-subtitle {
    color: ${({ theme }) => theme.colors.text.secondary} !important;
  }

  /* Global Ant Design button primary override */
  .ant-btn-primary {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
    border-color: ${({ theme }) => theme.colors.primary.base} !important;

    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.colors.primary[700]} !important;
      border-color: ${({ theme }) => theme.colors.primary[700]} !important;
    }
  }

  /* Ant Design Input standardization */
  .ant-input,
  .ant-input-affix-wrapper {
    height: 40px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize.base};
    padding: 0 ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.colors.surface};
    color: ${({ theme }) => theme.colors.text.primary};
    transition:
      border-color ${({ theme }) => theme.transition.base},
      background-color ${({ theme }) => theme.transition.base};
  }

  .ant-input:focus,
  .ant-input-focused,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    box-shadow: none !important;
  }

  /* InputNumber no mesmo padrão do .ant-input (altura/borda/cores do tema). */
  .ant-input-number {
    width: 100%;
    height: 40px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    background-color: ${({ theme }) => theme.colors.surface};
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize.base};
    transition: border-color ${({ theme }) => theme.transition.base};
  }

  .ant-input-number-focused,
  .ant-input-number:focus {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    box-shadow: none !important;
  }

  .ant-input-number-input {
    height: 38px;
    padding: 0 ${({ theme }) => theme.spacing[3]};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: transparent;
    font-size: ${({ theme }) => theme.fontSize.base};
    border: none;
    box-shadow: none;
  }

  .ant-input-affix-wrapper > input.ant-input {
    border: none;
    height: auto;
    padding: 0;
    background-color: transparent !important;
    color: inherit;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.surface}
        inset !important;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.colors.text.primary} !important;
      caret-color: ${({ theme }) => theme.colors.text.primary};
      transition: background-color 5000s ease-in-out 0s;
    }
  }

  .ant-input-affix-wrapper .ant-input-suffix {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.text.muted};
  }

  .ant-input-password-icon {
    color: ${({ theme }) => theme.colors.text.muted} !important;
    &:hover {
      color: ${({ theme }) => theme.colors.text.secondary} !important;
    }
  }

  /* Ant Design Form label standardization */
  .ant-form-item-label > label {
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize.base};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  .ant-form-item-explain,
  .ant-form-item-extra {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-form-item-explain-error {
    color: ${({ theme }) => theme.colors.error.base} !important;
  }

  .ant-form-item-has-error .ant-input,
  .ant-form-item-has-error .ant-input:hover,
  .ant-form-item-has-error .ant-input:focus,
  .ant-form-item-has-error .ant-input-affix-wrapper,
  .ant-form-item-has-error .ant-input-affix-wrapper:hover,
  .ant-form-item-has-error .ant-input-affix-wrapper-focused {
    background-color: ${({ theme }) => theme.colors.surface} !important;
    color: ${({ theme }) => theme.colors.text.primary} !important;
    border-color: ${({ theme }) => theme.colors.error.base} !important;
  }

  /* Ant Design Tag - shadcn-style badges with theme support */
  .ant-tag {
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    border-radius: 9999px;
    padding: 2px 10px;
    line-height: 20px;
    border: 1px solid transparent;
  }

  .ant-tag-green {
    background-color: ${({ theme }) => theme.colors.tag.green.bg} !important;
    color: ${({ theme }) => theme.colors.tag.green.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.green.border} !important;
  }

  .ant-tag-red {
    background-color: ${({ theme }) => theme.colors.tag.red.bg} !important;
    color: ${({ theme }) => theme.colors.tag.red.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.red.border} !important;
  }

  .ant-tag-orange {
    background-color: ${({ theme }) => theme.colors.tag.orange.bg} !important;
    color: ${({ theme }) => theme.colors.tag.orange.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.orange.border} !important;
  }

  .ant-tag-blue {
    background-color: ${({ theme }) => theme.colors.tag.blue.bg} !important;
    color: ${({ theme }) => theme.colors.tag.blue.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.blue.border} !important;
  }

  .ant-tag-geekblue {
    background-color: ${({ theme }) => theme.colors.tag.geekblue.bg} !important;
    color: ${({ theme }) => theme.colors.tag.geekblue.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.geekblue.border} !important;
  }

  .ant-tag-cyan {
    background-color: ${({ theme }) => theme.colors.tag.cyan.bg} !important;
    color: ${({ theme }) => theme.colors.tag.cyan.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.cyan.border} !important;
  }

  .ant-tag-purple {
    background-color: ${({ theme }) => theme.colors.tag.purple.bg} !important;
    color: ${({ theme }) => theme.colors.tag.purple.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.purple.border} !important;
  }

  .ant-tag-volcano {
    background-color: ${({ theme }) => theme.colors.tag.volcano.bg} !important;
    color: ${({ theme }) => theme.colors.tag.volcano.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.volcano.border} !important;
  }

  .ant-tag-gold {
    background-color: ${({ theme }) => theme.colors.tag.gold.bg} !important;
    color: ${({ theme }) => theme.colors.tag.gold.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.gold.border} !important;
  }

  .ant-tag-lime {
    background-color: ${({ theme }) => theme.colors.tag.lime.bg} !important;
    color: ${({ theme }) => theme.colors.tag.lime.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.lime.border} !important;
  }

  .ant-tag-magenta {
    background-color: ${({ theme }) => theme.colors.tag.magenta.bg} !important;
    color: ${({ theme }) => theme.colors.tag.magenta.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.magenta.border} !important;
  }

  .ant-tag-pink {
    background-color: ${({ theme }) => theme.colors.tag.pink.bg} !important;
    color: ${({ theme }) => theme.colors.tag.pink.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.pink.border} !important;
  }

  .ant-tag-teal {
    background-color: ${({ theme }) => theme.colors.tag.teal.bg} !important;
    color: ${({ theme }) => theme.colors.tag.teal.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.teal.border} !important;
  }

  .ant-tag-amber {
    background-color: ${({ theme }) => theme.colors.tag.amber.bg} !important;
    color: ${({ theme }) => theme.colors.tag.amber.text} !important;
    border-color: ${({ theme }) => theme.colors.tag.amber.border} !important;
  }

  /* Ant Design Progress - SPK dark blue */
  .ant-progress-circle .ant-progress-circle-path {
    stroke: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-progress-line .ant-progress-bg {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-progress-text {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-spin-dot-item,
  .ant-spin-spinning .ant-spin-dot-item,
  .ant-spin-nested-loading .ant-spin-dot-item,
  .ant-table-wrapper .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-spin,
  .ant-spin-nested-loading > div > .ant-spin {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-btn-loading-icon .anticon {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-btn-primary .ant-btn-loading-icon .anticon {
    color: #ffffff !important;
  }

  /* Ant Design Pagination standardization */
  .ant-pagination-item {
    background-color: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.border};
    transition: all ${({ theme }) => theme.transition.fast};

    a {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  .ant-pagination-item:hover {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    transform: translateY(-1px);
  }

  .ant-pagination-item-active {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-pagination-item:hover a,
  .ant-pagination-item-active a {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    transition: transform ${({ theme }) => theme.transition.fast};

    &:hover:not(.ant-pagination-disabled) {
      transform: translateY(-1px);
    }
  }

  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.text.primary};
    transition: all ${({ theme }) => theme.transition.fast};
  }

  .ant-pagination-prev:not(.ant-pagination-disabled):hover
    .ant-pagination-item-link,
  .ant-pagination-next:not(.ant-pagination-disabled):hover
    .ant-pagination-item-link {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    color: ${({ theme }) => theme.colors.primary.base} !important;
    transform: translateY(-1px);
  }

  .ant-pagination-disabled .ant-pagination-item-link {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-pagination-options-size-changer.ant-select {
    width: auto !important;
    height: 32px !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-family: ${({ theme }) => theme.fontFamily};
  }

  .ant-pagination-options-size-changer.ant-select:hover {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-select-arrow {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-select-clear {
    color: ${({ theme }) => theme.colors.text.muted} !important;
    background: ${({ theme }) => theme.colors.surface} !important;

    &:hover {
      color: ${({ theme }) => theme.colors.text.secondary} !important;
      background: ${({ theme }) => theme.colors.surface} !important;
    }
  }

  .ant-pagination-options-size-changer .ant-select-selector {
    height: 100% !important;
    padding: 0 8px !important;
    font-size: ${({ theme }) => theme.fontSize.sm} !important;
  }

  /* Ant Design Table - dark mode aware */
  .ant-table-wrapper {
    overflow-x: auto;
  }

  .ant-table {
    background-color: ${({ theme }) => theme.colors.surface};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .ant-table-thead > tr > th {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[100]} !important;
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    font-size: ${({ theme }) => theme.fontSize.sm};
    color: ${({ theme }) => theme.colors.text.secondary};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    text-transform: uppercase;
  }

  /* Table sort icons - use SPK dark blue */
  .ant-table-column-sorter-up.active,
  .ant-table-column-sorter-down.active {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-table-column-sorters:hover .ant-table-column-sorter {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceHover
        : theme.colors.neutral[200]} !important;
  }

  .ant-table-filter-trigger.active {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-table-tbody > tr:nth-child(even) > td {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[50]};
  }

  .ant-table-tbody > tr:nth-child(odd) > td {
    background-color: ${({ theme }) => theme.colors.surface};
  }

  .ant-table-tbody > tr:hover > td {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceHover
        : theme.colors.neutral[100]} !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    font-size: ${({ theme }) => theme.fontSize.sm};
    color: ${({ theme }) => theme.colors.text.primary};
    transition: background-color ${({ theme }) => theme.transition.fast};
  }

  /* Ant Design Empty */
  .ant-empty-description {
    color: ${({ theme }) => theme.colors.text.muted};
  }

  /* Ant Design Popover - dark mode */
  .ant-popover-inner {
    background-color: ${({ theme }) => theme.colors.surface};
  }

  .ant-popover-message-title {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .ant-popover-arrow-content {
    background-color: ${({ theme }) => theme.colors.surface};
  }

  /* Ant Design Input disabled (inclui o wrapper com prefixo, ex.: "R$") */
  .ant-input[disabled],
  .ant-input-disabled,
  .ant-input-affix-wrapper-disabled {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[100]} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
    color: ${({ theme }) => theme.colors.text.muted} !important;
    cursor: not-allowed;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.text.muted};
  }

  /* Dentro do wrapper desabilitado, o input não repete o fundo (evita o
     "degrau" torto) e o prefixo fica na cor apagada do tema. */
  .ant-input-affix-wrapper-disabled .ant-input[disabled] {
    background-color: transparent !important;
    border: none !important;
  }

  .ant-input-affix-wrapper-disabled .ant-input-prefix {
    color: ${({ theme }) => theme.colors.text.muted};
  }

  /* Ant Design Select disabled */
  .ant-select-disabled.ant-select:not(.ant-pagination-options-size-changer) {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[100]} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
    cursor: not-allowed;
  }

  .ant-select-disabled .ant-select-selector {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[100]} !important;
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-select-disabled .ant-select-selection-item {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-select-disabled .ant-select-arrow {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  /* Ant Design Notification */
  .ant-notification-notice {
    background-color: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.border};
    box-shadow: ${({ theme }) => theme.shadows.lg};
    border-radius: ${({ theme }) => theme.borderRadius.md};
  }

  .ant-notification-notice-message {
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  }

  .ant-notification-notice-description {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  .ant-notification-notice-close {
    color: ${({ theme }) => theme.colors.text.muted};

    &:hover {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  .ant-notification-notice-icon-success {
    color: ${({ theme }) => theme.colors.success.base} !important;
  }

  .ant-notification-notice-icon-info {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-notification-notice-icon-error {
    color: ${({ theme }) => theme.colors.error.base} !important;
  }

  .ant-notification-notice-icon-warning {
    color: ${({ theme }) => theme.colors.warning.base} !important;
  }

  /* Ant Design Skeleton - dark mode */
  .ant-skeleton-content .ant-skeleton-title,
  .ant-skeleton-content .ant-skeleton-paragraph > li {
    background: ${({ theme }) =>
      theme.mode === 'dark'
        ? 'linear-gradient(90deg, ' +
          theme.colors.surfaceRaised +
          ' 25%, ' +
          theme.colors.surfaceHover +
          ' 37%, ' +
          theme.colors.surfaceRaised +
          ' 63%)'
        : undefined};
  }

  .ant-checkbox-inner {
    height: 18px !important;
    width: 18px !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: ${({ theme }) => theme.borderRadius.sm} !important;
    background-color: ${({ theme }) => theme.colors.surface} !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  /* Ant Design DatePicker / RangePicker standardization */
  .ant-picker {
    height: 40px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize.base};
    padding: 0 ${({ theme }) => theme.spacing[3]};
    background-color: ${({ theme }) => theme.colors.surface};
    color: ${({ theme }) => theme.colors.text.primary};
    transition:
      border-color ${({ theme }) => theme.transition.base},
      background-color ${({ theme }) => theme.transition.base};
  }

  .ant-picker:hover {
    border-color: ${({ theme }) => theme.colors.primary.base};
  }

  .ant-picker-focused {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
    box-shadow: none !important;
  }

  .ant-picker input {
    color: ${({ theme }) => theme.colors.text.primary} !important;
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize.base};
    border: none !important;
    height: auto !important;
    line-height: normal !important;
    width: auto !important;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .ant-picker input:focus,
  .ant-picker input:focus-visible {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .ant-picker input::placeholder {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-picker-suffix,
  .ant-picker-separator {
    color: ${({ theme }) => theme.colors.text.muted} !important;
    display: flex;
    align-items: center;
  }

  .ant-picker-clear {
    color: ${({ theme }) => theme.colors.text.muted} !important;
    background: ${({ theme }) => theme.colors.surface} !important;
    display: flex;
    align-items: center;
    opacity: 1 !important;
  }

  .ant-picker-clear:hover {
    color: ${({ theme }) => theme.colors.text.secondary} !important;
    background: ${({ theme }) => theme.colors.surface} !important;
  }

  .ant-picker-dropdown {
    background: transparent;
  }

  .ant-picker-range-arrow {
    box-shadow: none !important;
  }

  .ant-picker-range-arrow::before {
    background: ${({ theme }) => theme.colors.surface} !important;
  }

  .ant-picker-panel-container {
    background-color: ${({ theme }) => theme.colors.surface} !important;
    border: 1px solid ${({ theme }) => theme.colors.border};
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  .ant-picker-panel {
    background-color: ${({ theme }) => theme.colors.surface} !important;
    border: none !important;
  }

  .ant-picker-header {
    color: ${({ theme }) => theme.colors.text.primary};
    border-bottom-color: ${({ theme }) => theme.colors.border} !important;
    background-color: ${({ theme }) => theme.colors.surface} !important;
  }

  .ant-picker-header button {
    color: ${({ theme }) => theme.colors.text.muted} !important;
    background: none !important;
    border: none !important;
    line-height: 40px !important;
    &:hover {
      color: ${({ theme }) => theme.colors.primary.base} !important;
    }
  }

  .ant-picker-body {
    background-color: ${({ theme }) => theme.colors.surface} !important;
  }

  .ant-picker-content th {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-picker-cell {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-picker-cell-in-view {
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(
      .ant-picker-cell-range-start
    ):not(.ant-picker-cell-range-end)
    .ant-picker-cell-inner {
    background-color: ${({ theme }) => theme.colors.surfaceHover} !important;
  }

  .ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background-color: ${({ theme }) => theme.colors.primary.base} !important;
    color: #ffffff !important;
  }

  /* Range background (between start and end) */
  .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
    background: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.primary.base + '22'
        : theme.colors.primary.base + '18'} !important;
  }

  /* Range start/end connecting background */
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
      .ant-picker-cell-range-start-single
    )::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
      .ant-picker-cell-range-end-single
    )::before {
    background: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.primary.base + '22'
        : theme.colors.primary.base + '18'} !important;
  }

  /* Hover over cells already in range */
  .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
      .ant-picker-cell-range-start-single
    ).ant-picker-cell-range-hover-start::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
      .ant-picker-cell-range-end-single
    ).ant-picker-cell-range-hover-end::before,
  .ant-picker-panel
    > :not(.ant-picker-date-panel)
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start::before,
  .ant-picker-panel
    > :not(.ant-picker-date-panel)
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before {
    background: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.primary.base + '44'
        : theme.colors.primary.base + '30'} !important;
  }

  /* Hover inner ::after overlay on range cells */
  .ant-picker-date-panel
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start
    .ant-picker-cell-inner::after,
  .ant-picker-date-panel
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end
    .ant-picker-cell-inner::after {
    background: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.primary.base + '44'
        : theme.colors.primary.base + '30'} !important;
  }

  /* Dashed border for hover preview outside range */
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(
      .ant-picker-cell-in-range
    ):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(
      .ant-picker-cell-in-range
    ):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(
      .ant-picker-cell-in-range
    )::after {
    border-top-color: ${({ theme }) => theme.colors.primary.base}88 !important;
    border-bottom-color: ${({ theme }) =>
      theme.colors.primary.base}88 !important;
  }

  .ant-picker-cell-range-hover-start::after,
  .ant-picker-cell-range-hover-end::after,
  .ant-picker-cell-range-hover::after {
    border-color: ${({ theme }) => theme.colors.primary.base}88 !important;
  }

  .ant-picker-today-btn {
    color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-picker-cell-today .ant-picker-cell-inner::before {
    border-color: ${({ theme }) => theme.colors.primary.base} !important;
  }

  .ant-picker-footer {
    border-top-color: ${({ theme }) => theme.colors.border} !important;
  }

  .ant-picker-disabled {
    background-color: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.surfaceRaised
        : theme.colors.neutral[100]} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
    cursor: not-allowed;
  }

  .ant-picker-disabled input {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  /* Ant Design Tooltip - dark mode aware */
  .ant-tooltip-inner {
    background-color: ${({ theme }) =>
      theme.mode === 'dark' ? theme.colors.surfaceRaised : undefined};
  }

  /* Checkbox / Radio: texto do rótulo segue o tema (dark mode) */
  .ant-checkbox-wrapper,
  .ant-radio-wrapper {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  /* Collapse: tematiza cabeçalho e conteúdo (dark mode) */
  .ant-collapse {
    background-color: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.border};
  }
  .ant-collapse > .ant-collapse-item {
    border-bottom-color: ${({ theme }) => theme.colors.border};
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: ${({ theme }) => theme.colors.text.primary};
  }
  .ant-collapse-content {
    background-color: ${({ theme }) => theme.colors.surface};
    border-top-color: ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  /* SpkCreatableSelect: opção com nome à esquerda e "remover" (X) à direita,
     que só aparece ao passar o mouse na opção. */
  .spk-cs-dropdown {
    .spk-cs-option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }
    .spk-cs-option-del {
      display: inline-flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.text.muted};
      opacity: 0;
      transition: opacity ${({ theme }) => theme.transition.fast};
    }
    .ant-select-item-option:hover .spk-cs-option-del,
    .ant-select-item-option-active .spk-cs-option-del {
      opacity: 1;
    }
    .spk-cs-option-del:hover {
      color: ${({ theme }) => theme.colors.error.base};
    }

    /* Bloco "Adicionar categoria": segue o tema (light/dark) do sistema. */
    .ant-divider {
      border-top-color: ${({ theme }) => theme.colors.border};
    }
    .spk-cs-add {
      display: flex;
      flex-direction: column;
      gap: ${({ theme }) => theme.spacing[2]};
      padding: ${({ theme }) => theme.spacing[1]}
        ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[2]};
    }
    /* O input do "adicionar" não deve herdar o estado de erro do Form.Item
       (borda vermelha / fundo claro no dark) nem ficar com texto ilegível. */
    .spk-cs-add .ant-input,
    .spk-cs-add .ant-input:hover,
    .spk-cs-add .ant-input:focus {
      background: ${({ theme }) => theme.colors.surface} !important;
      color: ${({ theme }) => theme.colors.text.primary} !important;
      border-color: ${({ theme }) => theme.colors.border} !important;
      box-shadow: none !important;
    }
    .spk-cs-add .ant-input:focus {
      border-color: ${({ theme }) => theme.colors.primary.base} !important;
    }
    .spk-cs-add .ant-input::placeholder {
      color: ${({ theme }) => theme.colors.text.secondary} !important;
      opacity: 1;
    }
    .spk-cs-add-btn {
      display: block;
      width: 100%;
    }
  }

  /* Estado de erro do select criável: borda vermelha legível em dark/light,
     sem o fundo avermelhado padrão do antd que quebra no dark. */
  .ant-form-item-has-error
    .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) {
    border-color: ${({ theme }) => theme.colors.error.base} !important;
  }
  .ant-form-item-has-error .ant-select .ant-select-selector {
    background-color: ${({ theme }) => theme.colors.surface} !important;
  }

  /* Contador do showCount (ex.: 0/120): a cor padrão do antd fica ilegível no
     dark mode. Usa o token de texto secundário e evita quebra de linha. */
  .ant-input-textarea-show-count::after,
  .ant-input-show-count-suffix {
    color: ${({ theme }) => theme.colors.text.secondary} !important;
    white-space: nowrap;
  }

  /* Afasta o contador da borda inferior (ex.: dentro de blocos adicionáveis). */
  .ant-input-textarea-show-count::after {
    margin-bottom: 6px;
  }

  /* Cores fixas do antd: o antd.css é estático e pinta ícones e textos com
     rgba(0, 0, 0, x), que somem no dark mode. Tudo abaixo passa para os tokens
     do tema. Lista levantada varrendo o antd.css pelos componentes que o app
     usa; componente novo do antd precisa entrar aqui também. */

  /* Ícones de remover/limpar/fechar e afins */
  .ant-select-multiple .ant-select-selection-item-remove,
  .ant-tag-close-icon,
  .ant-input-clear-icon,
  .anticon.ant-input-clear-icon,
  .ant-table-filter-dropdown-search-input .anticon,
  .ant-dropdown-menu-submenu-arrow-icon,
  .ant-menu-submenu-arrow,
  .ant-menu-submenu-expand-icon,
  .ant-input-number-handler,
  .ant-input-number-handler-up-inner,
  .ant-input-number-handler-down-inner,
  .ant-pagination-item-ellipsis,
  .ant-form-item-label > label .ant-form-item-tooltip {
    color: ${({ theme }) => theme.colors.text.muted} !important;
  }

  .ant-select-multiple .ant-select-selection-item-remove:hover,
  .ant-tag-close-icon:hover,
  .ant-input-clear-icon:hover,
  .anticon.ant-input-clear-icon:hover,
  .ant-input-number-handler:hover .ant-input-number-handler-up-inner,
  .ant-input-number-handler:hover .ant-input-number-handler-down-inner {
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .ant-input-number-handler-wrap,
  .ant-input-number-handler {
    background: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.border};
  }

  /* Textos secundários */
  .ant-select-item-empty,
  .ant-select-dropdown-empty,
  .ant-select-item-group,
  .ant-empty-normal,
  .ant-empty-small,
  .ant-dropdown-menu-item-group-title,
  .ant-menu-item-group-title,
  .ant-form-item-label > label .ant-form-item-optional,
  .ant-table-tbody > tr.ant-table-placeholder,
  .ant-spin-tip {
    color: ${({ theme }) => theme.colors.text.secondary} !important;
  }

  /* Textos principais */
  .ant-select-auto-complete,
  .ant-checkbox-group,
  .ant-divider-with-text,
  .ant-input-group,
  .ant-input-number-group,
  .ant-input-number-affix-wrapper,
  .ant-picker-input > input,
  .ant-pagination-options-quick-jumper,
  .ant-pagination-options-quick-jumper input,
  .ant-table-footer,
  .ant-message,
  .ant-btn-dashed,
  .ant-btn-ghost {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .ant-input-group-addon,
  .ant-input-number-group-addon {
    color: ${({ theme }) => theme.colors.text.secondary};
    background-color: ${({ theme }) => theme.colors.surfaceHover};
    border-color: ${({ theme }) => theme.colors.border};
  }

  .ant-table-footer {
    background: ${({ theme }) => theme.colors.surfaceHover};
  }

  /* Dropdown/Menu (ex.: menus de ação das listagens) */
  .ant-dropdown,
  .ant-dropdown-menu,
  .ant-table-filter-dropdown {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .ant-dropdown-menu,
  .ant-table-filter-dropdown {
    background-color: ${({ theme }) => theme.colors.surface};
  }

  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    color: ${({ theme }) => theme.colors.text.primary};

    &:hover {
      background-color: ${({ theme }) => theme.colors.surfaceHover};
    }
  }
`;
